import { Children, useEffect, useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
  ModalDeleteCore,
  TableRowCore,
  TableCore,
  TdCore,
} from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  EditIcon,
  FolderOffIcon,
  InfoOutlinedIcon,
  DeleteForeverIcon,
  CurrencyExchangeIcon,
  ReplayIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { handleFormatDateDayWeek } from "src/shared/Utils/FormatDate/FormatDateToDayWeek";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FilterSidebar } from "../FilterSidebar/FilterSidebar";
import {
  ModalUpdateStatusContrato,
  statusContract,
} from "../FormCancelContrato/FormCancelContrato";

import { UseGetByIdContratos } from "./Hooks/UseGetByIdContratos";
import { useHttpTableContratos } from "./Hooks/useHttpTableContratos";
import { THeadContratos } from "./THead";
import { ModalGetDataTitular } from "../ModalGetDataTitular";
import { ModalContratos } from "../Form";
import { IListContratos } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { Box, Chip, IconButton, Menu, Typography } from "@mui/material";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { useGetSheetContracts } from "./Hooks/useGetSheetContracts";
import { CopyCore } from "src/Pages/components/CopyCore/CopyCore";
import { useRestoreContrato } from "./Hooks/useRestoreContrato";

export const objStatusContractColor = {
  APPROVED: "#3cb916",
  CANCELLED: "#D0021B",
  PENDING: "#0e6aff",
  VALIDATION: "#8b0eff",
  NAO_EFETIVADO: "#ff9800",
  CANCELAR_DELETAR_PARCELAS: "#bf360c",
};

export const TableContratos = () => {
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { handleGetSheetContracts, loading: loadingGetSheetContracts } = useGetSheetContracts();
  const {
    valueAutoCompOperadoraFilter,
    valueAutoCompProdutorActive,
    valueAutoCompAdministradora,
    valueAutoCompModalidade,
  } = UseAutoCompletedAll();
  const { handleGet } = useHttpTableContratos();

  const navigate = useNavigate();

  const {
    listContratos,
    valuesFilterContrato,
    setValuesInputCancelarContrato,
  } = useContextContrato();

  const { handleGetById } = UseGetByIdContratos();

  const [openModalStatus, setOpenModalStatus] = useState(false);
  const [openModalContrato, setOpenModalContrato] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    setActive_incluir,
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
  } = useConfigPageContext();

  const handleGetIdToEdit = (id: string) => {
    setId(id);
    setOpenModalContrato(true);
    handleGetById(id);
  };

  useEffect(() => {
    handleGet({
      currentPage,
      itensPerPage,
      nameSearch,

      codProposta: valuesFilterContrato.cod_proposta,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      codeCorretor: valueAutoCompProdutorActive.id,
      codeAdministradora: valueAutoCompAdministradora.id,

      endDateSignature: valuesFilterContrato.endDateSignature,
      startDateSignature: valuesFilterContrato.startDateSignature,

      startEffectiveDate: valuesFilterContrato.startEffectiveDate,
      startDateEmission: valuesFilterContrato.startDateEmission,

      endDateEmission: valuesFilterContrato.startDateEmission,
      endEffectiveDate: valuesFilterContrato.endEffectiveDate,

      startVencimentoDate: valuesFilterContrato.startVencimentoDate,
      endVencimentoDate: valuesFilterContrato.endVencimentoDate,

      modalidade_code: valueAutoCompModalidade.id,

      client: {
        nameOrRazao: valuesFilterContrato.nameOrRazao,
        cpfCnpj: valuesFilterContrato.cpfCnpj,
      },
      status: valuesFilterContrato.status,
      isDeleted: valuesFilterContrato.isDeleted,
    });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/contratos" });

  const {
    handleRestore,
    open: openModalRestore,
    loading: loadingRestore,
    setId: setIdModalRestore,
    setOpen: setOpenModalRestore,
  } = useRestoreContrato();

  const handleCancelContract = (id: string, item: IListContratos) => {
    setValuesInputCancelarContrato({
      date: handleFormatDateIfIsNull(item.date_update_status),
      description: item.description_status,
      status: item.status,
    });

    setId(id);
    setOpenModalStatus(true);
  };

  return (
    <TableCore
      Modals={
        <>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
            transformOrigin={{ vertical: 'top', horizontal: 'center', }}
            slotProps={{ paper: { sx: { width: "240px", } } }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              sx={{ p: 2, }}
            >
              <Typography
                fontSize="13px"
                color="text.secondary"
                fontWeight={500}
                textAlign="center"
                mb={1}
              >
                Baixe todos os contratos em Excel <br /> conforme o filtro que você aplicou.
              </Typography>
              <ButtonCore
                title="Baixar Excel"
                variant="contained"
                disabled={loadingGetSheetContracts}
                onClick={() => {
                  handleGetSheetContracts({
                    currentPage,
                    itensPerPage,
                    nameSearch,

                    codProposta: valuesFilterContrato.cod_proposta,
                    codeOperadora: valueAutoCompOperadoraFilter.id,
                    codeCorretor: valueAutoCompProdutorActive.id,
                    codeAdministradora: valueAutoCompAdministradora.id,

                    endDateSignature: valuesFilterContrato.endDateSignature,
                    startDateSignature: valuesFilterContrato.startDateSignature,

                    startEffectiveDate: valuesFilterContrato.startEffectiveDate,
                    startDateEmission: valuesFilterContrato.startDateEmission,

                    endDateEmission: valuesFilterContrato.startDateEmission,
                    endEffectiveDate: valuesFilterContrato.endEffectiveDate,

                    startVencimentoDate: valuesFilterContrato.startVencimentoDate,
                    endVencimentoDate: valuesFilterContrato.endVencimentoDate,

                    modalidade_code: valueAutoCompModalidade.id,

                    client: {
                      nameOrRazao: valuesFilterContrato.nameOrRazao,
                      cpfCnpj: valuesFilterContrato.cpfCnpj,
                    },
                    status: valuesFilterContrato.status,

                    isVitalicioCorretora: valuesFilterContrato.isVitalicioCorretora,
                    isVitalicioCorretor: valuesFilterContrato.isVitalicioCorretor,
                    isVitalicioSupervisor: valuesFilterContrato.isVitalicioSupervisor,
                    isVitalicioGerente: valuesFilterContrato.isVitalicioGerente,


                    isDeleted: valuesFilterContrato.isDeleted,
                  });
                }}
                sx={{
                  mt: 1,
                  color: "#fff",
                  boxShadow: "0 1px 7px 0 rgba(8,80,160,0.13)",
                  fontWeight: 600,
                  letterSpacing: ".03em",
                  textTransform: "none",
                  px: 2,
                  py: .7,
                  fontSize: "13px",
                  transition: "background 0.3s",
                }}
                startIcon={<SaveAltIcon />}
              />
            </Box>
          </Menu>
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={handleDelete}
          />
          <ModalDeleteCore
            loading={loadingRestore}
            modalOpen={openModalRestore}
            no="Não, Cancelar"
            titlePrimary="Você deseja restaurar este contrato ?"
            yes="Sim, Restaurar !"
            onClickFalse={() => setOpenModalRestore(false)}
            onClickTrue={handleRestore}
          />

          <ModalUpdateStatusContrato
            openModalStatus={openModalStatus}
            setOpenModalStatus={setOpenModalStatus}
          />

          <ModalGetDataTitular />
        </>
      }
      cardAdd={{
        title: "Contratos",
        icon: <DocumentScannerIcon color="primary" />,
        subTitle: "Controle todos os contratos.",
        buttonAdd: [
          <ButtonCore
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant="outlined"
            title="Baixar Excel"
            startIcon={<SaveAltIcon />}
          />,
          <ModalContratos
            key={1}
            openModal={openModalContrato}
            setOpenModal={setOpenModalContrato}
          />,
        ],
      }}
      THead={<THeadContratos />}
      filter={<FilterSidebar />}
      qtdList={listContratos.length}
      setNameSearch={setNameSearch}
    >
      {Children.toArray(
        listContratos.map((item) => {
          const isContractDeleted =
            item.is_deleted ?? item.isDeleted ?? Boolean(item.deleted_at);

          return (
            <TableRowCore id={item.id}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <CurrencyExchangeIcon fontSize="small" />,
                        title: "Ver Contrato",
                        background: "success",
                        onClick: () => {
                          navigate(`/Lancamentos/contrato/${item.id}`);
                        },
                      },
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.CONTRATO.EDITAR.id
                        ),
                        onClick: () => {
                          setId(item.id);
                          handleGetIdToEdit(item.id);
                          setActive_incluir(true);
                        },
                      },
                      {
                        title: "Alterar status",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.CONTRATO.CANCELAR.id
                        ),
                        background: "warning",
                        onClick: () => {
                          handleCancelContract(item.id, item);
                        },
                        icon: <FolderOffIcon fontSize="small" />,
                      },
                      {
                        title: isContractDeleted ? "Restaurar" : "Excluir",
                        background: isContractDeleted ? "success" : "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.CONTRATO.DELETAR.id
                        ),
                        onClick: () => {
                          if (isContractDeleted) {
                            setIdModalRestore(item.id);
                            setOpenModalRestore(true);
                            return;
                          }

                          setIdModalDelete(item.id);
                          setOpenModalDelete(true);
                        },
                        icon: isContractDeleted ? (
                          <ReplayIcon fontSize="small" />
                        ) : (
                          <DeleteForeverIcon fontSize="small" />
                        ),
                      },
                    ]}
                  />
                }
              />
              <TdCore
                textAlign="center"
                values={
                  <IconButton onClick={() => navigate(`/Lancamentos/contrato/${item.id}`)}>
                    <RemoveRedEyeIcon fontSize="small" sx={{ color: "#A6A6A6FF" }} />
                  </IconButton>
                }
              />
              <TdCore
                color={isContractDeleted ? "#D0021B" : objStatusContractColor[item.status]}
                sxStyle={{ fontSize: ".7rem" }}
                values={isContractDeleted ? "Deletado" : statusContract[item.status]}
                tooltip={
                  isContractDeleted
                    ? "Contrato deletado"
                    : item.description_status
                      ? item.description_status
                      : ""
                }
              />
              <TdCore
                color="#0e6aff"
                textAlign="right"
                tooltip={handleFormatDateDayWeek(
                  handleFormatDateIfIsNull(item.data_assinatura)
                )}
                values={
                  item.data_assinatura ? FormatDateBR(item.data_assinatura) : ""
                }
              />
              <TdCore
                values={
                  <Box sx={{ minWidth: "100%", }}>
                    <Chip
                      label={<CopyCore text={item.cod_proposta} sxStyle={{ minWidth: "100px" }} />}
                      sx={{ minWidth: "100%", justifyContent: "flex-start", }}
                      color="default"
                    />
                  </Box>
                }
              />

              <TdCore
                isLimit
                isLimitQTD={35}
                textAlign="left"
                values={`${item.name_operadoras}`}
                subTitle={`${item.name_modalidades}`}
              />

              <TdCore
                values={
                  item.tipo_contrato === "PF"
                    ? item.titular_pf
                    : item.razao_social_pj
                }
                subTitle={item.tipo_contrato === "PF"
                  ? cpfOurCnpj({ text: item.cpf_cnpj, type: "cpf" })
                  : cpfOurCnpj({ text: item.cpf_cnpj, type: "cnpj" })}
              />

              <TdCore
                color="#3cb916"
                textAlign="right"
                values={`R$ ${FormatMoney(item.mensalidade_value)}`}
              />

              <TdCore
                color={item.tipo_contrato === "PF" ? "#e4a022" : "#9357f5"}
                textAlign="center"
                values={item.tipo_contrato.toUpperCase()}
              />

              <TdCore
                subTitle={cpfOurCnpj({
                  text: item.telefone_2,
                  type: "phone",
                })}
                values={cpfOurCnpj({
                  text: item.telefone_1,
                  type: "phone",
                })}
              />

              <TdCore values={`${item.id_produtor} - ${item.nome_produtor}`} />

              <TdCore
                isLimit
                isLimitQTD={35}
                textAlign="left"
                values={
                  item.code_administradoras && `${item.name_administradoras}`
                }
              />
              <TdCore
                textAlign="center"
                tooltip={`Usuário com id: '${item?.id_user_create
                  }' criou na data: ${FormatDateBR(item.created_at)}
                  / Usuário com id '${item.id_user_update
                  }' Editou na data: ${FormatDateBR(item.update_at)}`}
                values={<InfoOutlinedIcon />}
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
